import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  const isJsonEditor = location.pathname === '/json-editor';
  const isCsvEditor = location.pathname === '/csv-editor';
  const logo = "./writewordstudio.png";

  const styles = {
    header: {
      width: "100%",
      height: "70px",
      boxShadow: "0 0 20px 0 rgba(0, 0, 0, 0.3)",
      display: "flex",
      alignItems: "center",
      position: "fixed",
      top: 0,
      backgroundColor: "#fff",
      zIndex: 1000,
      '@media (maxWidth: 768px)': {
        height: "40px",
      },
    },
    logo: {
      width: "40px",
      height: "40px",
      marginRight: "5px",
      paddingLeft: "10px",
    },
    brandText: {
      paddingLeft: "10px",
      color: "#32bc9b",
      fontWeight: "bold",
      fontSize: "20px",
    },
    nav: {
      marginLeft: "auto",
      marginRight: "20px",
      fontSize: "16px",
      '@media (maxWidth: 768px)': {
        fontSize: "12px",
      },
    },
    link: {
      color: "#32bc9b",
      textDecoration: "none",
      padding: "5px 10px",
      borderRadius: "5px",
      border: "1px solid #32bc9b",
    },
    spacer: {
      height: "70px",
      '@media (maxWidth: 768px)': {
        height: "40px",
      },
    }
  };

  return (
    <>
      <div style={styles.header}>
        <img src={logo} alt="WriteWordStudio" style={styles.logo} />
        <h1 style={styles.brandText}>Write</h1>
        <h1 style={styles.brandText}>Word</h1>
        <h1 style={styles.brandText}>Studio</h1>
        <nav style={styles.nav}>
          {isJsonEditor ? (
            <>
              <Link to="/" style={{ ...styles.link, marginRight: '10px' }}>テキストカウンター</Link>
              <Link to="/csv-editor" style={styles.link}>CSVエディター</Link>
            </>
          ) : isCsvEditor ? (
            <>
              <Link to="/" style={{ ...styles.link, marginRight: '10px' }}>テキストカウンター</Link>
              <Link to="/json-editor" style={styles.link}>JSONエディター</Link>
            </>
          ) : (
            <>
              <Link to="/json-editor" style={{ ...styles.link, marginRight: '10px' }}>JSONエディター</Link>
              <Link to="/csv-editor" style={styles.link}>CSVエディター</Link>
            </>
          )}
        </nav>
      </div>
      <div style={styles.spacer}></div>
    </>
  );
};

export default Header;
